import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import { FormattedMessage, useIntl } from 'react-intl'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  benefitValue: number
}

function LandingPageLoyaltyTourExpCreditBenefitsModal(props: Props) {
  const { image, benefitValue } = props
  const intl = useIntl()

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'zU9-VVwlxdrdGnD15pQr',
        defaultMessage: 'Extras on your tour',
        description: 'Title for the tour experience credit benefit details modal',
      })}
      />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="tour_exp_credit" />
            <BodyText variant="large">
              {intl.formatMessage({
                id: 'yXct7TJX2UFoYsgEcYuK',
                defaultMessage: 'Enjoy extra perks on your next adventure with a travel credit towards tour add-ons. Whether it’s a sunset cruise or a food tour, these extras are on us.',
                description: 'Description of the tour experience credit benefit in the details modal',
              })}
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">{intl.formatMessage({
                id: 'qY7_yt6SSGKnDAeugn_H',
                defaultMessage: 'How it works',
                description: 'Section heading explaining how the tour experience credit benefit works',
              })}
              </Heading>
              <BodyText variant="large">
                <FormattedMessage
                  id="qi8oA_dLfm9-lSwJW1Dd"
                  defaultMessage="Enhance your immersive small-group adventure with {creditAmount} to spend on optional extras. Whether it’s a handpicked cultural experience or a special add-on, you can customise your journey to suit your style.{br}{br}With exclusive tours designed by our travel experts and a dedicated tours concierge to assist, it’s seamless from start to finish.{br}{br}To activate, purchase a Luxury Escapes tour and contact customer service and we’ll organise your voucher."
                  description="Detailed explanation of the tour experience credit benefit and how to activate it"
                  values={{
                    creditAmount: <FormatCurrency value={benefitValue} format="dynamic" />,
                    br: <br />,
                  }}
                />
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTourExpCreditBenefitsModal
